const VALIDATION_PREFIX = 'Validation failed: '
const ROW_NUMBER_REGEX = /Row\s+(\d+)\s*:/
const TRUNCATION_REGEX = /\.\.\.\s+and\s+(\d+)\s+more error\(s\)\s*$/i

export const isValidationErrorMessage = errorMsg => {
  if (typeof errorMsg !== 'string') return false
  return errorMsg.includes('Validation failed') || errorMsg.includes('Row')
}

const compareByRowNumber = (a, b) => {
  const aMatch = a.match(ROW_NUMBER_REGEX)
  const bMatch = b.match(ROW_NUMBER_REGEX)

  const aRow = aMatch ? Number(aMatch[1]) : Number.POSITIVE_INFINITY
  const bRow = bMatch ? Number(bMatch[1]) : Number.POSITIVE_INFINITY

  if (aRow !== bRow) return aRow - bRow
  return a.localeCompare(b)
}

export const parseValidationErrors = errorMsg => {
  if (typeof errorMsg !== 'string' || !errorMsg.trim()) return []

  const normalized = errorMsg.startsWith(VALIDATION_PREFIX)
    ? errorMsg.slice(VALIDATION_PREFIX.length)
    : errorMsg

  return normalized
    .split('; ')
    .map(entry => entry.trim())
    .filter(Boolean)
    .sort(compareByRowNumber)
}

export const getValidationTruncationInfo = errorMsg => {
  if (typeof errorMsg !== 'string') return null

  const match = errorMsg.match(TRUNCATION_REGEX)
  if (!match) return null

  const additionalCount = Number(match[1])
  if (Number.isNaN(additionalCount)) return null

  return {
    isTruncated: true,
    additionalCount,
  }
}
